import React from 'react'
import Controller from '../Images/Controller.png'
import AppDev from '../Images/AppDev.png'
import WebDev from '../Images/WebDevelopment.png'
import VR from '../Images/VR.png'

function Services() {
  return (
    <div id='services' className='py-16 bg-gradient-to-b from-slate-50 to-white'>
        <div className='max-w-7xl mx-auto px-6 lg:px-8'>
            <h2 className='section-title'>Our Services</h2>
            
            <div className='grid gap-8 lg:gap-12'>
                {/* Game Development */}
                <div id='game' className='card p-8 lg:p-10'>
                    <div className='flex flex-col lg:flex-row items-center gap-8'>
                        <div className='flex-1 text-center lg:text-left'>
                            <h3 className='service-title flex items-center justify-center lg:justify-start gap-3'>
                                <div className='w-10 h-10 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center'>
                                    <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                                        <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'/>
                                    </svg>
                                </div>
                                Game Development
                            </h3>
                            <p className='text-slate-600 leading-relaxed mb-6'>
                                Need help developing your next big game idea? Look no further for expert game development consulting. From concept to launch, we'll guide you through the process and help bring your game to life. We also provide technical support services for those who are just looking to overcome a hurdle.
                            </p>
                            <p className='text-slate-600 mb-6'>
                                Want to learn more about our capabilities in game development? Check out our game development studio.
                            </p>
                            <a href='https://www.jimdublace.com' className='btn-primary inline-flex items-center gap-2 font-comfortaa'>
                                JimDublace Studios
                                <svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14' />
                                </svg>
                            </a>
                        </div>
                        <div className='flex-shrink-0'>
                            <div className='relative'>
                                <div className='absolute inset-0 bg-gradient-to-br from-purple-400 to-pink-400 rounded-2xl blur-lg opacity-30'></div>
                                <img src={Controller} className='relative rounded-2xl h-40 w-40 lg:h-48 lg:w-48 object-cover shadow-lg'/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Web Development */}
                <div id='web' className='card p-8 lg:p-10'>
                    <div className='flex flex-col lg:flex-row-reverse items-center gap-8'>
                        <div className='flex-1 text-center lg:text-left'>
                            <h3 className='service-title flex items-center justify-center lg:justify-start gap-3'>
                                <div className='w-10 h-10 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center'>
                                    <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                                        <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/>
                                    </svg>
                                </div>
                                Web Development
                            </h3>
                            <p className='text-slate-600 leading-relaxed'>
                                Do you need a landing page? There's no need to pay the hefty monthly fees from those other guys. Our websites are lightweight and low maintenance. We can also help you set up custom services to support your business like appointment booking, online marketplaces, and any other service your customers need to help them stay connected.
                            </p>
                        </div>
                        <div className='flex-shrink-0'>
                            <div className='relative'>
                                <div className='absolute inset-0 bg-gradient-to-br from-blue-400 to-cyan-400 rounded-2xl blur-lg opacity-30'></div>
                                <img src={WebDev} className='relative rounded-2xl h-40 w-40 lg:h-48 lg:w-48 object-cover shadow-lg'/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* App Development */}
                <div id='app' className='card p-8 lg:p-10'>
                    <div className='flex flex-col lg:flex-row items-center gap-8'>
                        <div className='flex-1 text-center lg:text-left'>
                            <h3 className='service-title flex items-center justify-center lg:justify-start gap-3'>
                                <div className='w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center'>
                                    <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                                        <path d='M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'/>
                                    </svg>
                                </div>
                                App Development
                            </h3>
                            <p className='text-slate-600 leading-relaxed'>
                                Are you ready to go mobile? We can help put your business in the palm of your customer's hands. No idea is too big or too small, and our toolkits allow for easy customization down the road as your business grows.
                            </p>
                        </div>
                        <div className='flex-shrink-0'>
                            <div className='relative'>
                                <div className='absolute inset-0 bg-gradient-to-br from-green-400 to-emerald-400 rounded-2xl blur-lg opacity-30'></div>
                                <img src={AppDev} className='relative rounded-2xl h-40 w-40 lg:h-48 lg:w-48 object-cover shadow-lg'/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* AR/VR */}
                <div id='vr' className='card p-8 lg:p-10'>
                    <div className='flex flex-col lg:flex-row-reverse items-center gap-8'>
                        <div className='flex-1 text-center lg:text-left'>
                            <h3 className='service-title flex items-center justify-center lg:justify-start gap-3'>
                                <div className='w-10 h-10 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center'>
                                    <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                                        <path d='M20.5 6c-.61 0-1.11.49-1.11 1.1v7.8c0 .61.49 1.1 1.11 1.1s1.1-.49 1.1-1.1V7.1c0-.61-.49-1.1-1.1-1.1zM8.5 12c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zm7 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5z'/>
                                    </svg>
                                </div>
                                AR/VR
                            </h3>
                            <p className='text-slate-600 leading-relaxed'>
                                Augmented Reality and Virtual Reality are the future of technology. We can help you develop custom AR/VR experiences for your business. Whether you're looking to create a virtual showroom, a custom training experience, or a new way to interact with your customers, we have the tools to help you succeed.
                            </p>
                        </div>
                        <div className='flex-shrink-0'>
                            <div className='relative'>
                                <div className='absolute inset-0 bg-gradient-to-br from-orange-400 to-red-400 rounded-2xl blur-lg opacity-30'></div>
                                <img src={VR} className='relative rounded-2xl h-40 w-40 lg:h-48 lg:w-48 object-cover shadow-lg'/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Services